import React from 'react';
import { SocialSharePlatformProvider } from '../SocialSharePlatformContext';
import { SocialSharePlatformProviderProps } from '../types';
import useLinkedInSocialShare from './useLinkedInSocialShare';

const LinkedInSocialShareProvider: React.FC<SocialSharePlatformProviderProps> = ({
  children,
}) => {
  const platformData = useLinkedInSocialShare();

  return (
    <SocialSharePlatformProvider value={platformData}>
      {children}
    </SocialSharePlatformProvider>
  );
};

export default LinkedInSocialShareProvider;
